// extracted by mini-css-extract-plugin
module.exports = {"form":"EntityForm_form__2_Y9N"};